(module=>{
    module.service('absoluteDifferencesService', [absoluteDifferencesService]);

    function absoluteDifferencesService(this: $TSFixMe) {
        var service = this;

        function calculateAbsoluteDifferences(currentValue: $TSFixMe, prevValue: $TSFixMe){
            return currentValue - prevValue;
        }

        service.calculateAbsoluteDiff = (forecast: $TSFixMe) => {
            var result = [null];
            for(let i =1, max = forecast.length; i<max; i++){
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
                result.push(calculateAbsoluteDifferences(forecast[i], forecast[i-1]));
            }
            return result;
        };

        service.calculateAbsoluteDiffForQuarters = (forecast: $TSFixMe) => {
            var result = [null, null, null, null];
            for(let i = 4, max = forecast.length; i<max; i++){
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
                result.push(calculateAbsoluteDifferences(forecast[i], forecast[i-4]));
            }
            return result;
        };

        service.calculateAbsoluteDiffForecast = (pmForecast: $TSFixMe, statisitcalForecast: $TSFixMe) =>{
            let result = [];
            for(let i = 0, max = statisitcalForecast.length; i<max; i++ ){
                result.push(calculateAbsoluteDifferences(pmForecast[i], statisitcalForecast[i]))
            }
            return result;
        };
    }


})(angular.module('topline.services'));